/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_LabelInputs */



/**
* | output |
* | --- |
* | "Directory (tenant) ID" |
*
* @param {Microsoft_Tenant_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_label = /** @type {((inputs?: Microsoft_Tenant_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verzeichnis-ID (Mandanten-ID)")
	return /** @type {LocalizedString} */ ("Directory (tenant) ID")
});